'use client';
import React, { useState, useEffect } from 'react';
import ImageDefault from '@src/assets/images/imageNoAvailable.png';
import Image from 'next/image';

const ImageWithFallback = ({
  fallback = ImageDefault,
  alt,
  src,
  className = '',
  isLCP = false,
  ...props
}) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  // Kiểm tra nếu src rỗng, render placeholder thay vì Image
  if (!src || (typeof src === 'string' && src.trim() === '')) {
    return (
      <div
        className={`w-full h-full bg-gray-200 flex items-center justify-center text-gray-500 ${className}`}
        style={{ width: props.width || '100%', height: props.height || '100%' }}
      >
        No Image
      </div>
    );
  }

  const finalProps = { ...props } as any;

  // Bridge legacy next/image props used in old components.
  if (finalProps.layout === 'fill') {
    finalProps.fill = true;
  }
  if (finalProps.objectFit) {
    finalProps.style = {
      ...(finalProps.style || {}),
      objectFit: finalProps.objectFit,
    };
  }
  delete finalProps.layout;
  delete finalProps.objectFit;

  if (finalProps.quality === undefined) {
    finalProps.quality = 75;
  }
  if (isLCP) {
    finalProps.fetchPriority = finalProps.fetchPriority || 'high';
    finalProps.loading = finalProps.loading || 'eager';
  }
  if (!finalProps.priority && finalProps.loading === undefined) {
    finalProps.loading = 'lazy';
  }

  return (
    <Image
      draggable="false" // Disable dragging
      alt={alt}
      onError={() => setError(true)}
      className={className}
      src={error ? fallback : src}
      data-islcp={isLCP || undefined}
      {...finalProps}
    />
  );
};

export default ImageWithFallback;
